<template>
  <div id="app" :style="appStyle">
    <login-modal></login-modal>
    <layout>
      <router-view />
    </layout>

    <SystemInfo></SystemInfo>

    <div class="loading" v-if="isLoading">
      <div>
        <LoadingBox :hasBorder="false"></LoadingBox>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import SystemInfo from '@/components/SystemInfo';
import LoginModal from '@/components/Common/LoginModal.vue';
import LoadingBox from '@/components/Common/LoadingBox.vue';
import {getLocalData, saveLocalData} from '@/lib/base/localData';
import {manifest} from '@/constant/env.js';
import {PROVINCE_LOCALE} from '@/constant/province.js';

export default {
  metaInfo() {
    const matched = this.$route.matched;
    const title = matched.findLast((m) => m.meta.title)?.meta.title;
    return {
      title,
      titleTemplate: `%s | ${manifest.name}`,
    };
  },
  components: {
    Layout,
    LoginModal,
    SystemInfo,
    LoadingBox,
  },
  computed: {
    device() {
      return this.$store.getters['env/device'];
    },
    appStyle() {
      return this.device.isMobile ? this.$store.state.env.appStyle : [];
    },
    deviceHeight() {
      return this.$store.state.env.height;
    },
    userData() {
      return this.$store.state.auth.userData;
    },
    isLoading() {
      return this.$store.state.env.isLoading;
    },
  },
  async created() {
    this.$store.dispatch('env/init');
    const userLocalCache = getLocalData('user');
    const jwt = getLocalData('jwt');
    const provinceId = this.$getProvinceId();

    const userLocale =
      navigator.languages && navigator.languages.length
        ? navigator.languages[0]
        : navigator.language;

    window.addEventListener('resize', () => {
      this.$store.dispatch('env/init');
    });
    if (!provinceId) {
      saveLocalData('provinceId', PROVINCE_LOCALE[userLocale]);
    }
    this.$store.dispatch('province/getProvince');

    if (userLocalCache) {
      this.$store.commit('auth/setLogin', JSON.parse(userLocalCache));
    }
    if (jwt) {
      await this.$store.dispatch('auth/getMe');
      if (
        this.$route.name !== 'personal' ||
        (this.$route.name === 'personal' && this.$route.query?.state !== 'exam')
      ) {
        await this.$store.dispatch('exam/getCurrentExams', this.userData.id);
      }
    }
    this.$store.dispatch('province/getCities', provinceId);
  },
};
</script>
<style lang="scss">
body {
  overflow: hidden;
}
#app {
  overflow: auto;
  color: $gray-900;
  background: $gray-100;
  .wrapper {
    flex-grow: 1;
  }
}
</style>

<style lang="scss" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  & > div {
    width: 218px;
  }
}
</style>
